module.exports = __webpack_public_path__ + "static/open-graph-c9dd44066073488f5479803cf5da7620.png";